export default __webpack_public_path__ + "static/media/A4.744a4822.mp3";